module.exports = __webpack_public_path__ + "img/youtube-thumbnails.aa955ab7.webp";